customElements.get("product-info") || customElements.define("product-info", class extends HTMLElement {
	quantityInput = void 0;
	quantityForm = void 0;
	onVariantChangeUnsubscriber = void 0;
	cartUpdateUnsubscriber = void 0;
	abortController = void 0;
	pendingRequestUrl = null;
	preProcessHtmlCallbacks = [];
	postProcessHtmlCallbacks = [];
	constructor() {
		super(), this.quantityInput = this.querySelector(".quantity__input")
	}
	connectedCallback() {
		this.initializeProductSwapUtility(), this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.optionValueSelectionChange, this.handleOptionValueChange.bind(this)), this.initQuantityHandlers(), this.dispatchEvent(new CustomEvent("product-info:loaded", {
			bubbles: !0
		}))
	}
	addPreProcessCallback(t) {
		this.preProcessHtmlCallbacks.push(t)
	}
	initQuantityHandlers() {
		this.quantityInput && (this.quantityForm = this.querySelector(".product-form__quantity"), this.quantityForm && (this.setQuantityBoundries(), this.dataset.originalSection || (this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this)))))
	}
	disconnectedCallback() {
		this.onVariantChangeUnsubscriber(), this.cartUpdateUnsubscriber?.()
	}
	initializeProductSwapUtility() {
		this.preProcessHtmlCallbacks.push((t => t.querySelectorAll(".scroll-trigger").forEach((t => t.classList.add("scroll-trigger--cancel"))))), this.postProcessHtmlCallbacks.push((t => {
			window?.Shopify?.PaymentButton?.init(), window?.ProductModel?.loadShopifyXR()
		}))
	}
	handleOptionValueChange({
		data: {
			event: t,
			target: e,
			selectedOptionValues: i
		}
	}) {
		if (!this.contains(t.target)) return;
		if ("radio" === t.target.type && !e.dataset.optionValueId) {
			this._bridgeSwatchToHiddenRadio(t.target);
			return;
		}
		if (this.dataset.quickAddRoot) this.productForm?.handleErrorMessage();
		else this.resetProductFormState();
		const a = e.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
		this.pendingRequestUrl = a;
		const r = this.dataset.url !== a,
			s = "true" === this.dataset.updateUrl && r;
		this.renderProductInfo({
			requestUrl: this.buildRequestUrlWithParams(a, i, s),
			targetId: e.id,
			callback: r ? this.handleSwapProduct(a, s) : this.handleUpdateProductInfo(a)
		})
	}
	_bridgeSwatchToHiddenRadio(t) {
		const e = t.closest("variant-selects");
		if (!e) return;
		const i = t.closest("fieldset"), a = i?.querySelector("legend");
		if (!a) return;
		const r = a.textContent.split(":")[0].trim().toLowerCase();
		const c = a.querySelector("span");
		if (c) c.textContent = " " + t.value;
		const s = e.querySelectorAll("fieldset.add-new");
		for (const n of s) {
			const o = n.querySelector("legend");
			if (!o || o.textContent.trim().toLowerCase().indexOf(r) === -1) continue;
			const l = Array.from(n.querySelectorAll('input[type="radio"]')).find((e => e.value.trim().toLowerCase() === t.value.trim().toLowerCase()));
			if (!l) continue;
			if (l.checked) return;
			l.checked = !0, l.dispatchEvent(new Event("change", {bubbles: !0}));
			return;
		}
	}
	resetProductFormState() {
		const t = this.productForm;
		t?.handleErrorMessage()
	}
	handleSwapProduct(t, e) {
		return i => {
			this.productModal?.remove();
			const a = e ? "product-info[id^='MainProduct']" : "product-info",
				r = this.getSelectedVariant(i.querySelector(a));
			this.updateURL(t, r?.id), e ? (document.querySelector("head title").innerHTML = i.querySelector("head title").innerHTML, HTMLUpdateUtility.viewTransition(document.querySelector("main"), i.querySelector("main"), this.preProcessHtmlCallbacks, this.postProcessHtmlCallbacks)) : HTMLUpdateUtility.viewTransition(this, i.querySelector("product-info"), this.preProcessHtmlCallbacks, this.postProcessHtmlCallbacks)
		}
	}
	renderProductInfo({
		requestUrl: t,
		targetId: e,
		callback: i
	}) {
		this.abortController?.abort(), this.abortController = new AbortController, fetch(t, {
			signal: this.abortController.signal
		}).then((t => t.text())).then((t => {
			this.pendingRequestUrl = null;
			const e = (new DOMParser).parseFromString(t, "text/html");
			i(e)
		})).then((() => {
			document.querySelector(`#${e}`)?.focus()
		})).catch((t => {
			"AbortError" === t.name ? console.log("Fetch aborted by user") : console.error(t)
		}))
	}
	getSelectedVariant(t) {
		const e = t.querySelector("variant-selects [data-selected-variant]")?.innerHTML;
		return e ? JSON.parse(e) : null
	}
	buildRequestUrlWithParams(t, e, i = !1) {
		const a = [], f = e.filter(Boolean);
		return !i && a.push(`section_id=${this.sectionId}`), f.length && a.push(`option_values=${f.join(",")}`), `${t}?${a.join("&")}`
	}
	updateOptionValues(t) {
		const e = this.variantSelectors,
			i = t.querySelector("variant-selects");
		if (!e || !i) return;
		const setIfChanged = (el, name, value) => {
			const current = el.getAttribute(name);
			if (value === null) { if (current !== null) el.removeAttribute(name); }
			else if (current !== value) el.setAttribute(name, value);
		};
		e.querySelectorAll("select").forEach((t => {
			const a = i.querySelector(`#${CSS.escape(t.id)}`);
			if (!a) return;
			if (t.selectedIndex !== a.selectedIndex) t.selectedIndex = a.selectedIndex;
			Array.from(t.options).forEach(((e, i) => {
				const r = a.options[i];
				if (r) {
					if (e.disabled !== r.disabled) e.disabled = r.disabled;
					if (e.selected !== r.selected) e.selected = r.selected;
					setIfChanged(e, "selected", r.hasAttribute("selected") ? "selected" : null);
					setIfChanged(e, "data-option-swatch-value", r.getAttribute("data-option-swatch-value"));
					setIfChanged(e, "data-option-swatch-focal-point", r.getAttribute("data-option-swatch-focal-point"));
					if (e.textContent !== r.textContent) e.textContent = r.textContent;
				} else {
					if (!e.disabled) e.disabled = !0;
					if (e.selected) e.selected = !1;
					if (e.hasAttribute("selected")) e.removeAttribute("selected");
				}
			}))
		})), e.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach((t => {
			const a = i.querySelector(`#${CSS.escape(t.id)}`);
			if (!a) return;
			if (t.checked !== a.checked) t.checked = a.checked;
			if (t.disabled !== a.disabled) t.disabled = a.disabled;
			const fetchedClass = a.getAttribute("class") || "";
			if ((t.getAttribute("class") || "") !== fetchedClass) {
				if (fetchedClass) t.setAttribute("class", fetchedClass);
				else t.removeAttribute("class");
			}
			setIfChanged(t, "aria-disabled", a.getAttribute("aria-disabled"));
			const r = e.querySelector(`label[for="${CSS.escape(t.id)}"]`),
				s = i.querySelector(`label[for="${CSS.escape(t.id)}"]`);
			if (r && s) {
				const fetchedLabelClass = s.getAttribute("class") || "";
				if ((r.getAttribute("class") || "") !== fetchedLabelClass) {
					if (fetchedLabelClass) r.setAttribute("class", fetchedLabelClass);
					else r.removeAttribute("class");
				}
				if (r.innerHTML !== s.innerHTML) r.innerHTML = s.innerHTML;
				Array.from(r.attributes).forEach((t => {
					if ("class" !== t.name && "for" !== t.name && !s.hasAttribute(t.name)) r.removeAttribute(t.name);
				}));
				Array.from(s.attributes).forEach((t => {
					if ("class" !== t.name && "for" !== t.name && r.getAttribute(t.name) !== t.value) r.setAttribute(t.name, t.value);
				}));
			}
		}));
		const a = i.querySelector('[data-selected-variant]'),
			r = e.querySelector('[data-selected-variant]');
		if (a && r && r.textContent !== a.textContent) r.textContent = a.textContent;
		const s = e.querySelectorAll("[data-selected-value]"),
			n = i.querySelectorAll("[data-selected-value]");
		s.forEach(((t, e) => {
			if (n[e] && t.innerHTML !== n[e].innerHTML) t.innerHTML = n[e].innerHTML;
		}))
	}
	handleUpdateProductInfo(t) {
		return e => {
			const i = this.getSelectedVariant(e),
				r = this.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`);
			if (r && i && r.hasAttribute("media-grouping-enabled") && (r.querySelectorAll("[data-media-group]").forEach((t => t.classList.add("hide-media"))), i.options.forEach((t => {
					r.querySelectorAll(`[data-media-group="${t}"]`).forEach((t => t.classList.remove("hide-media")))
				})), r.querySelectorAll("slider-component").forEach((t => {
					t.initPages()
				}))), this.updateOptionValues(e), this.updateURL(t, i?.id), this.updateVariantInputs(i?.id), !i) return void this.setUnavailable();
			this.updateMedia(e, i?.featured_media?.id);
			const s = (t, i = (t => !1)) => {
				const a = e.getElementById(`${t}-${this.sectionId}`),
					r = this.querySelector(`#${t}-${this.dataset.section}`);
				a && r && (r.innerHTML = a.innerHTML, r.classList.toggle("hidden", i(a)))
			};
			const n = (t => {
				const i = this.querySelectorAll(`[${t}]`);
				i.forEach(((i, a) => {
					const r = i.dataset.blockId,
						s = r ? e.querySelector(`[${t}][data-block-id="${CSS.escape(r)}"]`) : e.querySelectorAll(`[${t}]`)[a];
					s && (i.innerHTML = s.innerHTML)
				}))
			});
			s("price"), n("data-product-price-block"), n("data-product-inline-price-block"), s("Sku", (({
				classList: t
			}) => t.contains("hidden"))), s("Inventory", (({
				innerText: t
			}) => "" === t)), s("Volume"), s("Price-Per-Item", (({
				classList: t
			}) => t.contains("hidden"))), this.updateQuantityRules(this.sectionId, e), this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove("hidden"), this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove("hidden"), this.productForm?.toggleSubmitButton(e.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute("disabled") ?? !0, window.variantStrings.soldOut), publish(PUB_SUB_EVENTS.variantChange, {
				data: {
					sectionId: this.sectionId,
					html: e,
					variant: i
				}
			})
		}
	}
	updateVariantInputs(t) {
		let e = this.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
		e.length || (e = this.querySelectorAll('form[data-type="add-to-cart-form"]'));
		e.forEach((e => {
			const i = e.querySelector('input[name="id"]');
			i.value = t ?? "", i.dispatchEvent(new Event("change", {
				bubbles: !0
			}))
		}))
	}
	updateURL(t, e) {
		this.querySelector("share-button")?.updateUrl(`${window.shopUrl}${t}${e?`?variant=${e}`:""}`), "false" !== this.dataset.updateUrl && window.history.replaceState({}, "", `${t}${e?`?variant=${e}`:""}`)
	}
	setUnavailable() {
		this.productForm?.toggleSubmitButton(!0, window.variantStrings.unavailable);
		const t = ["price", "Inventory", "Sku", "Price-Per-Item", "Volume-Note", "Volume", "Quantity-Rules"].map((t => `#${t}-${this.dataset.section}`)).join(", ");
		this.querySelectorAll(t).forEach((({
			classList: t
		}) => t.add("hidden")))
	}
	updateMedia(t, e) {
		if (!e) return;
		const i = this.querySelector("media-gallery ul"),
			a = t.querySelector("media-gallery ul"),
			r = () => {
				this.hasAttribute("data-zoom-on-hover") && enableZoomOnHover(2);
				const t = Array.from(i.querySelectorAll("li[data-media-id]")),
					e = new Set(t.map((t => t.dataset.mediaId))),
					a = new Map(t.map(((t, e) => [t.dataset.mediaId, {
						item: t,
						index: e
					}])));
				return [t, e, a]
			};
		if (i && a) {
			let [t, e, s] = r();
			const n = Array.from(a.querySelectorAll("li[data-media-id]")),
				o = new Set(n.map((({
					dataset: t
				}) => t.mediaId)));
			let l = !1;
			for (let t = n.length - 1; t >= 0; t--) e.has(n[t].dataset.mediaId) || (i.prepend(n[t]), l = !0);
			for (let e = 0; e < t.length; e++) o.has(t[e].dataset.mediaId) || (t[e].remove(), l = !0);
			l && ([t, e, s] = r()), n.forEach(((a, n) => {
				const o = s.get(a.dataset.mediaId);
				o && o.index !== n && (i.insertBefore(o.item, i.querySelector(`li:nth-of-type(${n+1})`)), [t, e, s] = r())
			}))
		}
		this.querySelector("media-gallery")?.setActiveMedia?.(`${this.dataset.section}-${e}`, !0);
		const s = this.productModal?.querySelector(".product-media-modal__content"),
			n = t.querySelector("product-modal .product-media-modal__content");
		s && n && (s.innerHTML = n.innerHTML)
	}
	setQuantityBoundries() {
		const t = {
			cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
			min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
			max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
			step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1
		};
		let e = t.min;
		const i = null === t.max ? t.max : t.max - t.cartQuantity;
		null !== i && (e = Math.min(e, i)), t.cartQuantity >= t.min && (e = Math.min(e, t.step)), this.quantityInput.min = e, i ? this.quantityInput.max = i : this.quantityInput.removeAttribute("max"), this.quantityInput.value = e, publish(PUB_SUB_EVENTS.quantityUpdate, void 0)
	}
	fetchQuantityRules() {
		const t = this.productForm?.variantIdInput?.value;
		const e = this.querySelector(".quantity__rules-cart .loading__spinner");
		t && (e?.classList.remove("hidden"), fetch(`${this.dataset.url}?variant=${t}&section_id=${this.dataset.section}`).then((t => t.text())).then((t => {
			const e = (new DOMParser).parseFromString(t, "text/html");
			this.updateQuantityRules(this.dataset.section, e)
		})).catch((t => console.error(t))).finally((() => e?.classList.add("hidden"))))
	}
	updateQuantityRules(t, e) {
		if (!this.quantityInput) return;
		this.setQuantityBoundries();
		const i = e.getElementById(`Quantity-Form-${t}`),
			a = [".quantity__input", ".quantity__rules", ".quantity__label"];
		for (let t of a) {
			const e = this.quantityForm.querySelector(t),
				a = i.querySelector(t);
			if (e && a)
				if (".quantity__input" === t) {
					const t = ["data-cart-quantity", "data-min", "data-max", "step"];
					for (let i of t) {
						const t = a.getAttribute(i);
						null !== t ? e.setAttribute(i, t) : e.removeAttribute(i)
					}
				} else e.innerHTML = a.innerHTML
		}
	}
	get productForm() {
		return this.querySelector("product-form")
	}
	get productModal() {
		return document.querySelector(`#ProductModal-${this.dataset.section}`)
	}
	get variantSelectors() {
		return this.querySelector("variant-selects")
	}
	get relatedProducts() {
		const t = SectionId.getIdForSection(SectionId.parseId(this.sectionId), "related-products");
		return document.querySelector(`product-recommendations[data-section-id^="${t}"]`)
	}
	get sectionId() {
		return this.dataset.originalSection || this.dataset.section
	}
});
